import { render, staticRenderFns } from "./FillClaimType.vue?vue&type=template&id=678ee178&scoped=true"
import script from "./FillClaimType.vue?vue&type=script&lang=js"
export * from "./FillClaimType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ee178",
  null
  
)

export default component.exports